import { Component } from '@angular/core';

import { Blog } from '../../shared/data/models/collections/blog';
import { Request } from '../../shared/data/services/request-enum';
import { AbstractLocalizedComponent } from '../../shared/ui/abstract.localized.component';

@Component({
  selector: 'placeme-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.scss'],
})
export class BlogsComponent extends AbstractLocalizedComponent {
  blogs: Blog[];

  protected loadData(locale: string): void {
    this.blogs = null;
    this.collectionsService
      .query<{ blogs: Blog[] }>(Request.BLOGS, { sort: ['publication:desc'], locale })
      .subscribe(data => (this.blogs = data.blogs));
  }
}
